let targetPromotionId = null

export function setBonusModalTargetPromotionId(promotionId) {
    targetPromotionId = promotionId || null
}

export function getBonusModalTargetPromotionId() {
    return targetPromotionId
}

export function clearBonusModalTargetPromotionId() {
    targetPromotionId = null
}
